import { render, staticRenderFns } from "./Scrubber.vue?vue&type=template&id=673eae9b"
import script from "./Scrubber.vue?vue&type=script&lang=ts"
export * from "./Scrubber.vue?vue&type=script&lang=ts"
import style0 from "./Scrubber.vue?vue&type=style&index=0&id=673eae9b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports